import { registerPlugin } from '@capacitor/core';

export interface SprintWidgetData {
  sprintName: string;
  /** "ahead" | "behind" | "on-track" */
  status: string;
  /** "cut" | "bulk" | "maintain" */
  mode: string;
  /** Moving-average weight. Omit if unavailable. */
  displayWeight?: number | null;
  goalWeight?: number | null;
  /** e.g. "4/15" */
  goalDateLabel: string;
  /** e.g. "▲ 1.7 lb ahead" or "Tracking closely" */
  alignCopy: string;
  /** 6-digit hex color string, e.g. "#86efac" */
  alignColorHex: string;
  /** e.g. "+1.2 lb net" */
  netChangeLabel: string;
  /** e.g. "3.4 lb to go" */
  lbsToGoLabel: string;
  /** e.g. "12 days left" */
  daysLeftLabel: string;
  /** 0–100, position of planned weight on bar */
  plannedPct?: number | null;
  /** 0–100, position of actual weight on bar */
  actualPct?: number | null;
  /** 0–100, start of the gap region */
  gapStartPct?: number | null;
  /** 0–100, width of the gap region */
  gapWidthPct: number;
  /** e.g. "Start Jan 5 · 185 lbs" */
  startLabel: string;
  /** e.g. "Goal Mar 28 · 175 lbs" */
  goalLabel: string;
  /** e.g. "Now 182.3 lbs" */
  nowLabel: string;
  /** e.g. "Δ −2.7 lbs" */
  deltaLabel: string;
  /** e.g. "10d early", "3d late", or "" when on-track */
  daysEarlyLateLabel: string;
  /** Short M/DD date for bar start, e.g. "2/14" */
  startDateShort: string;
  /** Short M/DD date for bar goal, e.g. "4/15" */
  goalDateShort: string;
  /** Sprint start weight for bar left endpoint */
  barStartWeight?: number | null;
  /** 0–100, start of maintain good-range band (maintain mode only) */
  mGoodStartPct?: number | null;
  /** 0–100, end of maintain good-range band (maintain mode only) */
  mGoodEndPct?: number | null;
}

export interface SprintWidgetPlugin {
  updateWidgetData(data: SprintWidgetData): Promise<void>;
  clearWidgetData(): Promise<void>;
}

const SprintWidget = registerPlugin<SprintWidgetPlugin>('SprintWidget', {
  // No web implementation — only runs on native iOS.
  web: () => ({
    updateWidgetData: async () => {},
    clearWidgetData: async () => {},
  }),
});

export default SprintWidget;
